import { required, maxLength, minLength, minValue } from 'vuelidate/lib/validators'

// export function specialIssueValidations () {
//   return {
//     currentEnterpriseData: {
//       enterprise_related_company: { required },
//       enterprise_services: {
//         required,
//         maxLength: maxLength(100)
//       },
//       enterprise_employee_benefits: {
//         required,
//         maxLength: maxLength(100)
//       },
//       enterprise_employee_training_introduction: {
//         required,
//         maxLength: maxLength(100)
//       },
//       enterprise_recruiting_description: {
//         required,
//         maxLength: maxLength(100)
//       },
//       enterprise_hr_contact_person: { required },
//       enterprise_hr_contact_tel: { required },
//       enterprise_hr_contact_email: { required },
//       enterprise_work_portfolio: {
//         required,
//         maxLength: maxLength(100)
//       }
//     }
//   }
// }
export function recruitmentOrientationsValidations () {
  return {
    currentOrientationData: {
      orientation_slots: {
        required,
        minLength: minLength(1)
      }
    }
  }
}
export function campusRecruitingValidations () {
  return {
    currentExpoData: {
      expo_booth_quantity: {
        required,
        minValue: minValue(1)
      }
    }
  };
}

export function printAdvertisingValidations () {
  return {
    currentAdvertisingData: {
      ads: {
        required,
        minLength: minLength(1)
      }
    }
  };
}
